import React from 'react';
import * as util from "../../../other/util.js";
import FleetFormulas from "../../../share/formulas/fleet-formulas.js";
import FleetStep from "./fleet-step.js";

export class PendingLaunchFleetStep extends FleetStep {
    constructor(props) {
        super("LAUNCH");
    }

    doPreRenderPredictions(props, idx) {
        if (!this._hasStepStarted(props, idx)) {
            let required_fuel = FleetFormulas.getFuelForLaunch(props.fleet);
            props.prediction.removeCertainFuel(required_fuel);
        }
    }

    render(props, idx) {
        let fleet = props.fleet;

        let fuel = FleetFormulas.getFuelForLaunch(fleet);
        let duration = FleetFormulas.getTimeForLaunch(fleet, util.getGPS().ship_designs);

        return (
            <div>
                <p className="boring-info-text">Launching</p>
                <div>
                    <span className="boring-info-text">Time: </span>
                    <util.NiceInlineTimeSpan timeSpan={duration} />
                </div>
                <util.Fuel fuel={fuel} />
                <util.FuelEstimation style={{ float: "right" }} fuel={props.prediction} />
            </div>);
    }
}

export class FixedLaunchFleetStep extends FleetStep {
    doPreRenderPredictions(props, idx) {
        if (!this._hasStepStarted(props, idx)) {
            let required_fuel = props.task.steps[idx].fuel;
            props.prediction.removeCertainFuel(required_fuel);
        }
    }

    render(props, idx) {
        let task = props.task;
        let step = task.steps[idx];

        if (this._isStepDone(props, idx)) {
            return this._renderDone("Launching", idx);
        }

        let timer = (<util.NiceInlineTimeSpan timeSpan={step.duration} />);
        if (this.isStepActive(props, idx)) {
            timer = (<util.Timer date={step.finished} style={{ display: "inline" }} />);
        }

        return (
            <div>
                <span className="boring-info-text">Launching</span>
                <br />
                <util.FuelEstimation fuel={props.prediction} />
                <util.Fuel fuel={step.fuel} />
                <br />
                <span>
                    <span className="boring-info-text">Launch time: </span>
                    {timer}
                </span>
            </div>);
    }
}
